import { deleteDealLines, upsertDealLines } from '../../services/dealLines';
import { dealLineToRow } from '../../utils/dealLinesDb';

export function createDealActions({ deals }) {
  // Enregistre les lignes d'une affaire : supprime celles retirées, crée ou met à jour les autres.
  // Renvoie l'erreur de la base (null si tout est enregistré) : la fiche reste alors ouverte.
  async function saveDealLines(dealId, lignes) {
    const prev = deals.find((a) => a.id === dealId);
    const previousLines = (prev && prev.lignes) || [];
    const toDelete = previousLines
      .filter((l) => !lignes.some((x) => x.id === l.id))
      .map((l) => l.id);
    if (toDelete.length) {
      const { error } = await deleteDealLines(toDelete);
      if (error) return error;
    }
    if (!lignes.length) return null;
    const { error } = await upsertDealLines(dealId, dealLineToRow, lignes);
    return error || null;
  }

  return { saveDealLines };
}
